/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */

import React, { Component } from 'react';
// import ReactResizeDetector from 'react-resize-detector';
import Debouncer from '../Debouncer';
import { log } from '#emyw/core-lib';
import './Slider.css';
const debouncer = new Debouncer();
const isDefined = variable => Boolean(variable || variable === 0);

/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */
const capitalize = str => str.charAt(0).toUpperCase() + str.substr(1);
const join = function () {
  let str = '';
  for (var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++) {
    arr[_key] = arguments[_key];
  }
  arr.forEach(item => {
    if (item) {
      str = (str ? "".concat(str, " ") : '').concat(item);
    }
  });
  return str;
};

/**
 * Predefined constants
 * @type {Object}
 */
const constants = {
  orientation: {
    horizontal: {
      dimension: 'width',
      direction: 'left',
      reverseDirection: 'right',
      coordinate: 'x'
    },
    vertical: {
      dimension: 'height',
      direction: 'bottom',
      reverseDirection: 'top',
      coordinate: 'y'
    }
  }
};
export default class Slider extends Component {
  constructor(props, context) {
    super(props, context);
    // static getDerivedStateFromProps = (props, state) => {
    //     // console.log('props.value, state.value:', props.value, state.value);
    //     if (isDefined(props.value) && state.value !== props.value) return { value: props.value };
    //     return null;
    // }
    /* Handles ref automatically */
    // componentDidMount = () => {
    //     log.trace('slider mounted. this:', this);
    //     const { ref } = this.props;
    //     if (ref) {
    //         log.trace('calling ref prop with', this);
    //         ref(this);
    //     }
    // }
    this.componentDidUpdate = prevProps => {
      // log.trace('componentDidUpdate props.value, state.value, this.stateUpdate:', this.props.value, this.state.value);
      if (this.props.value !== prevProps.value && !Number.isNaN(this.props.value)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          value: this.props.value
        });
      }
    };
    /**
     * Clamp position between a range
     * @param  {number} - Value to be clamped
     * @param  {number} - Minimum value in range
     * @param  {number} - Maximum value in range
     * @return {number} - Clamped value
     */
    this.clamp = (value, min, max) => {
      const {
        minReal,
        maxReal
      } = this.getRealMinMax({
        min,
        max
      });
      return Math.min(Math.max(value, minReal), maxReal);
    };
    this.getRealMinMax = _ref => {
      let {
        min,
        max
      } = _ref;
      const real = {};
      if (max > min) {
        real.minReal = min;
        real.maxReal = max;
      } else {
        real.minReal = max;
        real.maxReal = min;
      }
      return real;
    };
    this.handleChange = (e, value) => {
      const {
        disabled,
        snapTo,
        snapProximity,
        onChange,
        onChangeComplete,
        value: valueProp,
        async,
        stateAndPropsControlled
      } = this.props;
      if (!disabled) {
        const valueAdj = isDefined(snapTo) && Math.abs(value - snapTo) <= snapProximity ? snapTo : value;
        // log.trace('Setting value state to', valueAdj);
        if (!isDefined(valueProp) || stateAndPropsControlled) {
          // log.trace('Setting value state to', valueAdj);
          this.setState({
            value: valueAdj
          });
        }
        // log.trace('Calling props.onChange with value ', valueAdj);
        if (async) {
          setTimeout(() => {
            debouncer.update(() => {
              onChange(e, valueAdj);
              if (onChangeComplete && !this.state.active) onChangeComplete(e, valueAdj);
            });
          }, 0);
        } else {
          onChange(e, valueAdj);
          if (onChangeComplete && !this.state.active) onChangeComplete(e, valueAdj);
        }
      }
    };
    /**
     * Format label/tooltip value
     * @param  {Number} - value
     * @return {Formatted Number}
     */
    this.handleFormat = value => {
      const {
        format
      } = this.props;
      return format ? format(value) : value;
    };
    /**
     * Attach event listeners to mousemove/mouseup events
     * @return {void}
     */
    this.handleStart = e => {
      const {
        onChangeStart
      } = this.props;
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.handleEnd);
      this.setState({
        active: true
      }, () => {
        if (onChangeStart) onChangeStart(e);
      });
    };
    /**
     * Handle drag/mousemove event
     * @param  {Object} e - Event object
     * @return {void}
     */
    this.handleDrag = e => {
      e.stopPropagation();
      const {
        target: {
          className,
          classList,
          dataset
        }
      } = e;
      if (className === 'rangeslider-markers-main') return;
      let value = this.getValueFromCoordinates(e);
      if (classList && classList.contains('rangeslider__label-item') && dataset.value) {
        value = parseFloat(dataset.value);
      }
      this.handleChange(e, value);
    };
    /**
     * Detach event listeners to mousemove/mouseup events
     * @return {void}
     */
    this.handleEnd = e => {
      const {
        onChangeComplete,
        async
      } = this.props;
      // log.warn(e.target.dataset);
      this.setState({
        active: false
      }, () => {
        if (onChangeComplete) onChangeComplete(e, this.state.value);
      });
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.handleEnd);
      if (async) debouncer.checkAwaitingUpdate();
    };
    /**
     * Support for key events on the slider handle
     * @param  {Object} e - Event object
     * @return {void}
     */
    this.handleKeyDown = e => {
      const {
        key /* , altKey, ctrlKey, shiftKey */
      } = e;
      // const funcKey = key.match(/F[1-9]/);
      // if (!(altKey || ctrlKey || shiftKey || funcKey)) {
      //     // log.trace('preventing default', altKey, ctrlKey, shiftKey);
      //     e.preventDefault();
      // }

      switch (key) {
        case 'ArrowLeft':
          this.handleBump(e, 'left');
          e.preventDefault();
          break;
        case 'ArrowRight':
          this.handleBump(e, 'right');
          e.preventDefault();
          break;
        case 'ArrowUp':
          this.handleBump(e, 'up');
          e.preventDefault();
          break;
        case 'ArrowDown':
          this.handleBump(e, 'down');
          e.preventDefault();
          break;
        default:
          break;
      }
    };
    this.handleBump = (e, direction) => {
      log.trace('handling bump', direction, 'e:', e);
      const {
        disabled,
        min,
        max,
        step,
        reverse,
        orientation
      } = this.props;
      const {
        minReal,
        maxReal
      } = this.getRealMinMax({
        min,
        max
      });
      const {
        value
      } = this.state;
      const range = maxReal - minReal;
      let stepSize = step;
      if (!stepSize) {
        if (range >= 5 && range <= 15) {
          stepSize = 1;
        } else {
          stepSize = range / 10;
        }
      }
      if (reverse && max > min || !reverse && min > max) stepSize *= -1;
      let sliderValue;
      if (orientation === 'vertical') {
        if (direction === 'up') {
          sliderValue = value + stepSize;
        } else if (direction === 'down') {
          sliderValue = value - stepSize;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (direction === 'left') {
          sliderValue = value - stepSize;
        } else if (direction === 'right') {
          sliderValue = value + stepSize;
        }
      }
      if (isDefined(sliderValue) && !disabled) {
        sliderValue = this.clamp(sliderValue, min, max);
        if (sliderValue === value) sliderValue = null;
        // log.trace('bumping slider from', value, 'to', sliderValue);
        if (isDefined(sliderValue)) this.handleChange(e, sliderValue);
      }
    };
    /**
     * Translate position of slider to slider value
     * @param  {number} pos - Current position/coordinate of slider
     * @return {number} value - Slider value
     */
    this.getValueFromPosition = (pos, limit) => {
      const {
        min,
        max,
        step: stepProp
      } = this.props;
      // const { minReal, maxReal } = this.getRealMinMax({ min, max });
      const step = stepProp || 0.0001; // Appear as infinitely small step size
      const percentage = this.clamp(pos, 0, limit) / (limit || 1);
      const baseVal = step * Math.round(percentage * (max - min) / step);
      const value = baseVal + min;
      return this.clamp(value, min, max);
    };
    /**
     * Calculate value based on x or y coordinate
     * @param  {Object} e - Event object
     * @return {number} value - Slider value
     */
    this.getValueFromCoordinates = e => {
      const {
        orientation,
        reverse
      } = this.props;
      const node = this.slider;
      // log.warn('this.slider', this.slider);
      const coordinateStyle = constants.orientation[orientation].coordinate;
      const limitStyle = constants.orientation[orientation].dimension;
      const directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      const clientCoordinateStyle = "client".concat(capitalize(coordinateStyle));
      const coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      const sliderBounds = node.getBoundingClientRect();
      const limit = sliderBounds[limitStyle];
      const direction = sliderBounds[directionStyle];
      const pos = orientation === 'vertical' && !reverse || orientation !== 'vertical' && reverse ? direction - coordinate : coordinate - direction;
      const value = this.getValueFromPosition(pos, limit);
      return value;
    };
    /**
     * Calculate position of slider based on its value
     * @param  {number} value - Current value of slider
     * @return {position} pos - Calculated position of slider based on value
     */
    this.getPositionFromValue = (value, label) => {
      const {
        min,
        max,
        orientation,
        reverse
      } = this.props;
      const inverse = label && (orientation === 'vertical' && !reverse || orientation !== 'vertical' && reverse);
      // const { minReal, maxReal } = this.getRealMinMax({ min, max });
      const diffMaxMin = max - min;
      const diffValMin = value - min;
      let percentage = diffValMin / diffMaxMin;
      if (inverse) percentage = 1 - percentage;
      return percentage * 100;
    };
    this.renderLabels = labels => /*#__PURE__*/React.createElement("div", {
      ref: sl => {
        this.labels = sl || this.labels;
      },
      className: "rangeslider-markers-main"
    }, labels);
    this.renderTicks = () => {
      const {
        min,
        max,
        step,
        tickColor
      } = this.props;
      const nTicks = Math.floor(Math.abs(max - min) / step + 1);
      return /*#__PURE__*/React.createElement("div", {
        className: "sliderTicks",
        style: {
          color: tickColor
        }
      }, [...Array(nTicks)].map((v, i) => /*#__PURE__*/React.createElement("div", {
        key: 'sliderTicks-'.concat(i)
      })));
    };
    // setSliderHeight = () => {
    //     const { sliderIdForLabelResize, labels } = this.props;
    //     const labelKeys = Object.keys(labels);
    //     let maxHeight = 0;
    //     if (labelKeys.length > 0) {
    //         for (const key of labelKeys) {
    //             const labelEl = document.getElementById(`${sliderIdForLabelResize}_${key}`);
    //             if (maxHeight < labelEl.clientHeight) maxHeight = labelEl.clientHeight;
    //         }
    //     }
    //     const slider = document.getElementById(sliderIdForLabelResize);
    //     slider.style.height = `calc(2em + ${maxHeight}px)`;
    // }
    this.onLabelResize = () => {
      clearTimeout(this.resizeSliderTimeout);
      this.resizeSliderTimeout = setTimeout(this.setSliderHeight, 100);
    };
    this.state = {
      value: isDefined(props.value) ? props.value : props.defaultValue,
      active: false
    };
  }
  render() {
    const {
      orientation,
      tooltip,
      reverse,
      labels,
      ticks,
      centerLabels,
      min,
      max,
      handleLabel,
      // sliderIdForLabelResize,
      disabled,
      style,
      step: stepProp,
      ...rest /* eslint-disable-line no-unused-vars */ // Allows passing in ref prop
    } = this.props;
    const step = stepProp || 0.0001; // Appear as infinitely small step size (prevent passing in step=0)
    const {
      value,
      active
    } = this.state;
    let className = "enjoySlider ".concat(orientation);
    if (Object.keys(labels).length) className = "".concat(className, " labeled");
    if (disabled) className = "".concat(className, " disabled");
    if (this.props.className) className = "".concat(className, " ").concat(this.props.className);
    const {
      dimension
    } = constants.orientation[orientation];
    const direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
    const position = this.getPositionFromValue(value);
    const fillStyle = {
      [dimension]: "".concat(position, "%")
    };
    const handleStyle = {
      [direction]: "".concat(position, "%")
    };
    const showTooltip = tooltip && active;
    const labelItems = [];
    let labelKeys = Object.keys(labels);
    if (labelKeys.length > 0) {
      labelKeys = labelKeys.sort((a, b) => reverse ? b - a : a - b);
      // log.trace({ labelKeys, labelKeysOriginal: Object.keys(labels), reverse });

      for (const key of labelKeys) {
        const labelPosition = this.getPositionFromValue(key, true);
        const labelStyle = {};
        if (centerLabels) {
          labelStyle.width = "".concat(Number((step / Math.abs(max - min) * 100).toFixed(3)), "%");
        } else {
          labelStyle[orientation === 'vertical' ? 'top' : 'left'] = "".concat(labelPosition, "%");
        }
        // const lProps = sliderIdForLabelResize ? { id: `${sliderIdForLabelResize}_${key}` } : null;
        labelItems.push( /*#__PURE__*/React.createElement("div", {
          // {...lProps}
          key: key,
          className: "rangeslider__label".concat(centerLabels ? '-centered' : ''),
          "data-value": key
          // onMouseDown={e => this.handleChange(e, key)}
          ,
          onMouseDown: !Number.isNaN(Number(key)) && (e => this.handleChange(e, Number(key)))
          // onMouseDown={this.handleDrag}
          // onTouchStart={this.handleStart}
          // onTouchEnd={this.handleEnd}
          ,
          style: labelStyle
        }, /*#__PURE__*/React.createElement("div", {
          className: "rangeslider__label-item"
        }, this.props.labels[key])));
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      ref: r => {
        if (r) {
          r.onclick = e => e.stopPropagation(); // eslint-disable-line no-param-reassign
          r.bump = this.handleBump; // eslint-disable-line no-param-reassign
        }
      },
      className: className,
      style: style
      // id={sliderIdForLabelResize}
    }, /*#__PURE__*/React.createElement("div", {
      className: "sliderComponent"
    }, /*#__PURE__*/React.createElement("div", {
      className: join('rangeslider', "rangeslider-".concat(orientation), reverse ? 'rangeslider-reverse' : ''),
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": value,
      "aria-orientation": orientation
    }, /*#__PURE__*/React.createElement("div", {
      className: "rangeslider-base",
      onMouseDown: this.handleDrag,
      onMouseUp: this.handleEnd,
      onTouchStart: this.handleStart,
      onTouchEnd: this.handleEnd
    }, /*#__PURE__*/React.createElement("div", {
      ref: s => {
        this.slider = s || this.slider;
      },
      className: "rangeslider-main"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rangeslider__fill",
      style: fillStyle
    }), /*#__PURE__*/React.createElement("div", {
      ref: sh => {
        this.handle = sh || this.handle;
      },
      className: "rangeslider__handle",
      onMouseDown: this.handleStart,
      onTouchMove: this.handleDrag,
      onTouchEnd: this.handleEnd,
      onKeyDown: this.handleKeyDown,
      style: handleStyle,
      tabIndex: 0
    }, showTooltip ? /*#__PURE__*/React.createElement("div", {
      ref: st => {
        this.tooltip = st || this.tooltip;
      },
      className: "rangeslider__handle-tooltip"
    }, /*#__PURE__*/React.createElement("span", null, this.handleFormat(value))) : null, /*#__PURE__*/React.createElement("div", {
      className: "rangeslider__handle-label"
    }, handleLabel)), ticks ? this.renderTicks() : null)), /*#__PURE__*/React.createElement("div", {
      className: "rangeslider-markers-base"
    }, labels ? this.renderLabels(labelItems) : null))));
  }
}
Slider.defaultProps = {
  min: 0,
  max: 10,
  value: null,
  defaultValue: 0,
  step: 0,
  orientation: 'horizontal',
  reverse: false,
  labels: {},
  centerLabels: false,
  tooltip: false,
  ticks: false,
  tickColor: 'white',
  disabled: false,
  snapTo: null,
  snapProximity: 1,
  onChange: () => null,
  className: null,
  style: null,
  // sliderIdForLabelResize: null,
  async: false,
  stateAndPropsControlled: false,
  handleLabel: '',
  format: undefined,
  onChangeStart: () => null,
  onChangeComplete: () => null
};

/* Export slider wrapped in another class as a workaround for the prop 'ref' */
// eslint-disable-next-line react/prefer-stateless-function
// export default class Slider extends React.Component {
//     render() {
//         return <SliderBase {...this.props} />;
//     }
// }